// src/context/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const login = (userData) => {
    console.log("🔑 Logging in:", userData);
    setUser(userData);
    localStorage.setItem("user", JSON.stringify(userData));
    localStorage.setItem("loginTime", Date.now()); // track login time
  };

  const logout = () => {
    console.log("🚪 Logging out (forced or manual)...");
    setUser(null);
    localStorage.removeItem("user");
    localStorage.removeItem("loginTime");
    window.location.href = "/em"; // redirect to login
  };

 useEffect(() => {
  const storedUser = localStorage.getItem("user");
  const loginTime = localStorage.getItem("loginTime");

  console.log("📦 useEffect fired. Stored user:", storedUser, "LoginTime:", loginTime);

  if (storedUser && loginTime) {
    const elapsed = Date.now() - parseInt(loginTime, 10);
    const oneHour = 5 * 60 * 60 * 1000; // 2 hours
    //  const oneHour = 10 * 60 * 1000;

    console.log("⏳ Elapsed ms:", elapsed, "Remaining:", oneHour - elapsed);

    if (elapsed < oneHour) {
      setUser(JSON.parse(storedUser));

      const timer = setTimeout(() => {
        console.log("⏰ Timer finished — calling logout()");
        logout();
      }, oneHour - elapsed);

      return () => {
        console.log("🧹 Clearing old timer");
        clearTimeout(timer);
      };
    } else {
      console.log("⌛ Session expired already — logging out immediately");
      logout();
    }
  }
}, []); // run only once on mount


  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
